// src/pages/NoticeRegister.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { useFormInput, dateFormatDateTime } from "@/utils";
import { Confirm, Loading, Toast } from "@/components";
import SearchAddress from "@/components/Modal/Common/SearchAddress";

import ReactQuill from "react-quill";
import "quill/dist/quill.snow.css";
import "react-quill/dist/quill.snow.css";

// noticeApi
import { useGetNoticeByIdQuery } from "@/redux/noticeApi";

/**
 * NoticeDetail
 * - 공지사항 보기 (READ)
 * - URL 파라미터: noticeId
 */
export const NoticeDetail = () => {
    const { noticeId } = useParams();
    const navigate = useNavigate();

    const { formData, handleChange, setFormData } = useFormInput({
        toastMsg: "",
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        addressPopupStatus: false,
        id: null,
    });

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    const { toastMsg, confirmStatus, addressPopupStatus } = formData;

    // 1) 모드 설정: noticeId 유무
    useEffect(() => {
        if (noticeId) {
            setFormData((prev) => ({
                ...prev,
                id: noticeId,
            }));
        }
    }, [noticeId, setFormData]);

    // 2) UPDATE 모드일 경우, 공지사항 상세조회
    const {
        data: noticeDetail,
        isLoading: isDetailLoading,
        error: detailError,
    } = useGetNoticeByIdQuery(noticeId, {
        skip: !noticeId, // noticeId 없으면 호출X
    });

    // 3) 상세조회 응답 → formData 매핑
    useEffect(() => {
        if (noticeDetail && noticeDetail.data) {
            setFormData((prev) => ({
                ...prev,
                ...noticeDetail.data,
            }));
        }
    }, [noticeDetail, setFormData]);

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management-form container">
                <div className="form-container">
                    <div className="form-head">
                        <div className="head-tit">
                            <span className="form_name">공지사항</span>
                            <span className="form_desc"></span>
                        </div>
                        <div className="head-options">
                            <button
                                type="button"
                                className="btn btn-save"
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                뒤로가기
                            </button>
                        </div>
                    </div>

                    <div className="form-content">
                        <div className="post-container">
                            <div className="post-head">
                                <span className="post-tit">{formData.title}</span>
                                <span className="post-date">{dateFormatDateTime(formData.createdAt, "YYYY-MM-DD HH:mm:ss")}</span>
                            </div>
                            <div className="post-content">
                                <p className="content-txt" dangerouslySetInnerHTML={{ __html: formData.content }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {formData.confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={formData.confirmStatus.confirmTitle}
                    description={formData.confirmStatus.confirmDescription}
                    buttons={formData.confirmStatus.confirmButtons}
                />
            )}

            {/* 주소 검색 팝업 */}
            {addressPopupStatus && (
                <SearchAddress
                    modalStatus={addressPopupStatus}
                    setModalStatus={() =>
                        setFormData((prev) => ({
                            ...prev,
                            addressPopupStatus: false,
                        }))
                    }
                    setAddress={(data) =>
                        setFormData((prev) => ({
                            ...prev,
                            address: data.address,
                            bCode: data.bcode,
                        }))
                    }
                />
            )}
        </>
    );
};
